/* eslint-disable*/

/**
Warning that step.id is null when the Wizard is first time rendering
https://github.com/americanexpress/react-albus/issues/29
**/

import React, { useState } from 'react'
import styled from 'styled-components'
//import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import BasicLayout from 'core/templates/BasicLayout'
//import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { withWizard, Steps, Step, wizardShape } from 'react-albus'
import WizardNavigation from 'core/components/wizard-navigation'

const StyledSteps = styled.div``

export const Wizards = props => {
  const { aSteps, wizard, aStepsActive, history } = props

  const { location } = history
  const { pathname } = location

  const renderStep = aSteps.map(stepItem => {
    const { hash, component, title, cssId, subTitle, backButtonText, nextButtonText } = stepItem

    /*const filteredASteps = aStepsActive.filter(currentStep => currentStep.hash === hash)

    const activeStep = filteredASteps[0]
    const { isActive, isStepPrincipal } = activeStep
*/
    return (
      <Step
        id={hash}
        class={cssId}
        key={hash}
        title={title}
        subTitle={subTitle}
        backButtonText={backButtonText}
        nextButtonText={nextButtonText}
        //isActive={isActive}
        //isStepPrincipal={isStepPrincipal}
        data-test="component-step"
      >
        {component}
      </Step>
    )
  })
  // key={location.pathname} to force render steps at each page

  const [openPreview, togglePreview] = useState(false)

  const onTogglePreview = () => {
    togglePreview(!openPreview)
  }
  return (
    <>
      <BasicLayout data-test="component-wizard">
        <WizardNavigation
          key={pathname}
          openPreview={openPreview}
          onTogglePreview={onTogglePreview}
        />
        <StyledSteps className="steps">
          <Steps data-test="component-steps">{renderStep}</Steps>
        </StyledSteps>
      </BasicLayout>
    </>
  )
}
/*
Wizard.propTypes = {
  aStepsActive: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string,
      isActive: PropTypes.bool
    })
  ).isRequired,
  aSteps: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string,
      title: PropTypes.element,
      subTitle: PropTypes.element,
      component: PropTypes.element
    })
  ).isRequired,
  wizard: wizardShape.isRequired
}
*/

export default withRouter(withWizard(Wizards))
